import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { VIA_ESPECIAL_TRANSPORTE_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    VIA_ESPECIAL_TRANSPORTE_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    VIA_ESPECIAL_TRANSPORTE_ENDPOINT,
    id
  ]);
}
